import React, { useState } from 'react'
import { withRouter } from 'react-router'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './OnboardingEventConfigPage.css' // We will create this

const OnboardingEventConfigPageUI = ({ context, eventList, loading, errorList, onRefreshClick, onDeleteClick, history }) => {
    return (
        <SuperUserSettingsPageUI context={context} className='pg_su_onboarding_events'>
            <div className='g_spacer_20'></div>

            <div className='g_flex_h g_flex_at_center g_flex_space_between header-section'>
                <h2 className='page-title'>Onboarding Event Configuration</h2>
                <div className='g_flex_h'>
                    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
                    <button className='btn btn-primary' style={{ marginLeft: '10px' }} onClick={() => history.push('/su/onboarding-events/new')}>Add New</button>
                </div>
            </div>

            {loading && <SpinnerComponentUI />}

            {errorList && errorList.length > 0 && <GenericErrorUI error={errorList[0]} />}

            {!loading && eventList && (
                <div className='table-responsive' style={{ overflow: 'visible' }}>
                    <table className='table table-hover event-config-table'>
                        <thead>
                            <tr>
                                <th>Event Name</th>
                                <th>Event Code</th>
                                <th>Template Name Whatsapp</th>
                                <th>Whatsapp Frequency (Hours)</th>
                                <th>Email Frequency (Hours)</th>
                                <th>isActive</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {eventList.map((event, index) => (
                                <EventRow key={index} event={event} history={history} onDeleteClick={onDeleteClick} isActive={event.isActive} />
                            ))}
                            {eventList.length === 0 && (
                                <tr>
                                    <td colSpan="6" className="text-center">No events found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </SuperUserSettingsPageUI>
    )
}

const EventRow = ({ event, history, onDeleteClick, isActive }) => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    }

    const onViewDetails = () => {
        history.push(`/su/onboarding-events/${event.eventCode}`);
    }

    const onEdit = () => {
        history.push(`/su/onboarding-events/${event.eventCode}/edit`);
    }

    const onDelete = () => {
        setMenuOpen(false);
        if (onDeleteClick) {
            onDeleteClick(event.eventCode);
        }
    }

    return (
        <tr>
            <td>{event.eventName}</td>
            <td>{event.eventCode}</td>
            <td>{event.whatsappTemplateName}</td>
            <td>{event.whatsappFrequencyDays}</td>
            <td>{event.emailFrequencyDays}</td>
            <td>{event.isActive ? 'Yes' : 'No'}</td>
            <td style={{ position: 'relative' }}>
                <div className="action-menu">
                    <div className="vertical-icon-parent" onClick={toggleMenu}>
                        <i className="icon-options-vertical "></i>
                    </div>
                    {menuOpen && (
                        <div className="dropdown-menu show" style={{ display: 'block', top: '25px', right: '0', left: 'auto' }}>
                            <div className="dropdown-item" onClick={onViewDetails}>View Details</div>
                            <div className="dropdown-item" onClick={onEdit}>Edit</div>
                            <div className="dropdown-item" onClick={onDelete}>Delete</div>
                        </div>
                    )}
                </div>
                {menuOpen && <div className="menu-overlay" onClick={() => setMenuOpen(false)}></div>}
            </td>
        </tr>
    )
}

export default withRouter(OnboardingEventConfigPageUI)
